import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g>
      <path
        d="M3.99992 2.6665H11.3333C11.6869 2.6665 12.026 2.80698 12.2761 3.05703C12.5261 3.30708 12.6666 3.64622 12.6666 3.99984V11.9998C12.6666 12.3535 12.5261 12.6926 12.2761 12.9426C12.026 13.1927 11.6869 13.3332 11.3333 13.3332H3.99992C3.82311 13.3332 3.65354 13.2629 3.52851 13.1379C3.40349 13.0129 3.33325 12.8433 3.33325 12.6665V3.33317C3.33325 3.15636 3.40349 2.98679 3.52851 2.86177C3.65354 2.73674 3.82311 2.6665 3.99992 2.6665M5.99992 2.6665V14.6665"
        strokeWidth="1.5"
      />
      <path d="M8.66675 5.3335H10.0001" />
      <path d="M8.66675 8H10.0001" />
    </g>
    <defs>
      <clipPath>
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
